module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-detail"
  }, [_c('div', {
    staticClass: "tip-detail__desc"
  }, _vm._l((_vm.detailDesc), function(item) {
    return _c('div', {
      key: item.type,
      ref: ("tip-info-" + (item.type)),
      refInFor: true,
      staticClass: "tip-detail__item"
    }, [_c('div', {
      staticClass: "tip-detail__item-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tip-detail__item-desc",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceWrap(item.desc))
      }
    })])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f660ab7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f660ab7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/activity/detail/common/TipInfo.vue
// module id = 2246
// module chunks = 47